<template>
	<v-card>
		<v-card-title>
			<span class="headline">مشخصات درخواست وام</span>
			<v-spacer />
			<v-btn @click="close" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-container fluid>
				<div>
					<v-row>
						<v-col cols="12" v-if="isLocked">
							<v-alert type="warning" outlined>این درخواست توسط {{ localData.lockedBy.user_FullName }} در
								دست بررسی می باشد.</v-alert>
						</v-col>
						<v-col cols="12" md="3">
							<v-card class="mb-4 pa-3 secondary--text" color="#eee" v-if="localData.agentModel">
								<div>
									<span class="grey--text darken-3">نماینده: </span>
									<span class="grey--text" v-if="localData.agentModel.parentAgentBusinessName">
										{{ localData.agentModel.parentAgentBusinessName }}/
									</span>
									{{ localData.agentModel.businessName }}
								</div>
								<div>
									<span class="grey--text darken-3">نحوه دریافت: </span>
									<span>{{ localData.chargeTypeTitle || localData.str_ChargeType }} </span>
									<small v-if="localData.chargeType === 0 && localData.loanModel">
										({{localData.otherPercent ? localData.otherPercent.checkoutDays :
											localData.agentModel.agentLoans.find(x => x.loanId ===
												localData.loanModel.id).defaultCheckoutDays}} روزه)
										&nbsp;&nbsp;
										({{localData.otherPercent ? localData.otherPercent.percent :
											localData.agentModel.agentLoans.find(x => x.loanId ===
												localData.loanModel.id).percent}} %)
									</small>
								</div>
							</v-card>
							<member-profile-header :data="localData.memberModel" :loading="loading" :showManageLoans="true" />
						</v-col>
						<v-col cols="12" md="9" class="pt-5">
							<v-card class="mb-3" style="background-color: whitesmoke;">
								<v-form ref="form" class="mx-2" lazy-validation>
									<v-row class="mb-2" style="margin: -9px; background-color: #eee;border-bottom: 1px dashed grey;border-top-left-radius: 10px;border-top-right-radius: 10px;">
										<v-col cols="12" md="6" class="text-center" style="border-left: 1px dashed grey;">
											تاریخ درخواست: <span class="secondary--text">{{
												localData.requestDate_Persian.date }}</span>
										</v-col>
										<v-col cols="12" md="6" class="text-center">
											وضعیت جاری درخواست: <span class="secondary--text">{{ localData.str_Status
											}}</span>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" md="12" class="pt-4">
											<v-select dense v-model="localData.loanModel" clearable required single-line return-object :items="loans" label="نوع وام*" item-text="title" item-value="id" />
										</v-col>
										<v-col cols="12" md="3" class="py-0">
											<v-text-money dense v-model="localData.amount" label="مبلغ" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
										</v-col>
										<v-col cols="12" md="3" class="pt-0">
											<v-text-field dense v-model="localData.installmentCount" label="تعداد اقساط" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'تعداد اقساط را به صورت صحیح وارد کنید']" required />
										</v-col>
										<v-col cols="12" md="3" class="pt-0">
											<v-text-field dense v-model="localData.monthGap" label="فاصله بین هر قسط" :error-messages="errorMessages" :rules="[() => localData.amount >= 0 || 'فاصله اقساط باید بزرگتر از 0 باشد']" required />
										</v-col>
										<v-col cols="12" md="3" class="pt-0">
											<v-text-money dense v-model="localData.installment" label="مبلغ هر قسط" :error-messages="errorMessages" :rules="[() => localData.installment >= 0 || 'مبلغ هر قسط باید بزرگتر از 0 باشد']" required />
										</v-col>
									</v-row>
									<v-row class="my-0">
										<v-col cols="12" class="py-0">
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 pt-6 text-left">
													تغییر وضعیت به:
												</v-col>
												<v-col cols="9" class="d-md-flex align-center">
													<v-select v-model="localData.status" required :items="statuses" style="max-width: 250px;" class="pt-0 mt-0 mx-2" label="وضعیت را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" :rules="[(val) => !!val || 'وضعیت درخواست را انتخاب کنید']" />
													<v-btn color="secondary" small text @click="() => { statusGroup = 0; loanRequestStatusesDialog = true }">
														مدیریت وضعیت ها
													</v-btn>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="12" class="py-0" v-if="localData.agentModel">
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 pt-5 text-left">
													وضعیت نماینده:
												</v-col>
												<v-col cols="9" class="d-md-flex align-center">
													<v-select v-model="localData.agentStatus" required :items="agentStatuses" style="max-width: 250px;" class="pt-0 mt-0 mx-2" label="وضعیت نماینده را انتخاب کنید" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" :rules="[(val) => !!val || 'وضعیت نماینده را انتخاب کنید']" />
													<v-btn color="secondary" small text @click="() => { statusGroup = 1; loanRequestStatusesDialog = true }">
														مدیریت وضعیت ها
													</v-btn>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="12" class="py-0 mb-3" v-if="localData.agentModel && localData.userLoan && localData.userLoan.agentDueDate_Persian">
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 pt-5 text-left">
													سررسید تسویه نماینده:
												</v-col>
												<v-col cols="9" class="d-md-flex align-center">
													{{ localData.userLoan.agentDueDate_Persian.date }}
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="12" class="pb-0">
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 py-0 text-left">
													نظر کارشناس (جهت ادمین):
												</v-col>
												<v-col cols="9" class="pl-0 py-0">
													<v-textarea rows="2" dense v-model="localData.adminDescriptionPrivate" outlined :error-messages="errorMessages" />
												</v-col>
											</v-row>
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 py-0 text-left">
													نظر کارشناس (جهت مشتری):
												</v-col>
												<v-col cols="9" class="pl-0 py-0">
													<v-textarea rows="2" dense v-model="localData.adminDescription" outlined :error-messages="errorMessages" />
												</v-col>
											</v-row>
											<v-row class="mx-0">
												<v-col cols="3" class="px-0 py-0 text-left">
													کالاها و خدمات:
												</v-col>
												<v-col cols="9" class="pl-0 py-0">
													<v-textarea rows="2" dense v-model="localData.products" outlined readonly />
												</v-col>
											</v-row>
											<v-checkbox color="secondary" class="py-0 my-0" hide-details compact v-model="localData.isPhysicalDocsDelivered" :label="'مدارک ارسال شده به دست شرکت رسیده است'" />
										</v-col>
									</v-row>
									<div class="text-left">
										<v-btn class="mb-3" :loading="statusHistoryLoading" color="secondary" title="تغییر وضعیت ها" icon dark @click="showChangeStatusHistory()">
											<v-icon>mdi-account-edit-outline</v-icon>
											<v-badge :content="countStatusHistory + ''" top color="secondary lighten-2" offset-x="15" offset-y="-7">
											</v-badge>
										</v-btn>
										<v-btn class="mb-3" :loading="smsHistoryLoading" color="secondary" title="پیامک ها" icon dark @click="showSmsHistory()">
											<v-icon>mdi-chat-outline</v-icon>
											<v-badge :content="countSms + ''" top color="secondary lighten-2" offset-x="15" offset-y="-7">
											</v-badge>
										</v-btn>
										<v-btn class="mb-3 ml-2" v-if="!!localData.userLoan.code" :disabled="true" outlined color="secondary" @click="createUserLoanClick()">
											{{ `وام شماره ${localData.userLoan.code}` }}
										</v-btn>
										<v-btn class="mb-3 ml-2" v-else color="secondary" outlined dark @click="createUserLoanClick()">
											تبدیل به وام
										</v-btn>

										<v-btn v-if="!isLocked" class="mb-3" color="secondary" :loading="loading2" dark @click="submit()">
											ذخیره تغییرات
										</v-btn>
									</div>
								</v-form>
							</v-card>
							<v-card class="mb-3 mt-6" style="background-color: whitesmoke;" v-if="checkActivePart('sponsor')">
								<div class="text-center mb-6 py-2" style="background-color: #eee;border-bottom: 1px dashed grey;border-top-left-radius: 10px;border-top-right-radius: 10px;">
									مدیریت اسپانسر
								</div>
								<v-form ref="formSponsor" class="mx-2" lazy-validation>
									<v-row class="mx-0">
										<v-col cols="3" class="px-0 py-0 text-left">
											اسپانسر:
										</v-col>
										<v-col cols="9" class="pl-0 py-0 d-flex">
											<v-select style="max-width:250px" dense v-model="localData.sponsorModel" clearable required single-line return-object :items="sponsors" label="اسپانسر" item-text="businessName" item-value="id" />
											<span class="mr-2">آخرین وضعیت:</span>
											<span class="mr-1 grey--text">{{localData.sponsorModel &&
												sponsorStatuses.find(x => x.id === localData.userLoanSponsorStatus) ?
												sponsorStatuses.find(x => x.id ===
													localData.userLoanSponsorStatus).title : '-'}}</span>
										</v-col>
									</v-row>
									<v-row class="mx-0">
										<v-col cols="3" class="px-0 py-0 text-left">
											آخرین توضیحات اسپانسر:
										</v-col>
										<v-col cols="9" class="pl-0 py-0">
											<v-textarea rows="2" dense v-model="localData.lastSponsorComment" outlined :error-messages="errorMessages" />
										</v-col>
									</v-row>
									<div class="text-left">
										<v-btn class="mb-3 ml-1" :loading="sponsorHistoryLoading" color="secondary" title="تاریخچه تغییرات" icon dark @click="loadSponsorHistory()">
											<v-icon>mdi-account-edit-outline</v-icon>
											<v-badge :content="localData.sponsorHistoryCount + ''" top color="secondary lighten-2" offset-x="15" offset-y="-7">
											</v-badge>
										</v-btn>
										<v-btn v-if="!isLocked" class="mb-3" color="secondary" :loading="loading2" dark @click="submitSponsor()">
											ذخیره اسپانسر
										</v-btn>
									</div>
								</v-form>
								<div class="px-3" v-if="showSponsorHistoryList">
									<v-alert type="info" outlined class="mb-1" v-if="!sponsorHistoryList.length">تاریخچه
										ای یافت نشد.</v-alert>
									<div v-else>
										<v-card elevation="1" class="pa-2 mb-3" color="white" v-for="history in sponsorHistoryList" :key="history.id">
											<v-row class="my-0">
												<v-col cols="12" sm="4" class="d-flex py-0">
													<v-icon color="success" small class="ml-">mdi-calendar</v-icon>
													<small class="ml-1">تاریخ و ساعت:</small>
													<small class="grey--text">&lrm;{{ history.dateTime_Persian.date }}
														{{ history.dateTime_Persian.time }}</small>
												</v-col>
												<v-col cols="12" sm="4" class="d-flex py-0">
													<v-icon color="success" small class="ml-">mdi-account</v-icon>
													<small class="ml-1">توسط:</small>
													<small class="grey--text">{{ history.user.fullName }}</small>
												</v-col>
												<v-col cols="12" sm="4" class="d-flex py-0">
													<v-icon color="success" small class="ml-">mdi-leaf</v-icon>
													<small class="ml-1">موضوع:</small>
													<small class="grey--text">{{ history.subject }}</small>
												</v-col>
												<v-col cols="12" sm="12" class="d-flex py-0">
													<small class="ml-1">شرح:</small>
													<p class="text-justify ma-0" style="white-space: pre-line;">
														<small class="grey--text">{{ history.description }}</small>
													</p>
												</v-col>
											</v-row>
										</v-card>
									</div>
								</div>
							</v-card>
							<div class="">
								<div class="text-h3 grey--text my-2">مدارک:</div>
								<div v-if="authorizeStepLoading" class="success--text text-h4 text-center">
									در حال دریافت اطلاعات ...
								</div>
								<v-alert type="success" outlined class="mb-1" v-if="authorizationItems.length === 0 && !authorizeStepLoading">وام دارای مدارک نمی
									باشد.</v-alert>
								<v-row class="mt-2 justify-center">
									<v-col cols="12" sm="12" md="11" class="px-5" v-for="(auth, index) in authorizationItems" :key="auth.id + auth.status">
										<v-card class="mb-4" elevation="4">
											<div class="text-center text-h4 white--text pa-2 grey" style="border-top-left-radius: 10px; border-top-right-radius: 10px">
												{{ auth.authorizationItem.title }}
											</div>
											<div class="pa-3">
												<div class="text-center" style="border-bottom: 1px dashed #ddd;white-space: pre-line;" v-if="auth.authorizationItem.description && ![5, 6].includes(auth.authorizationItem.systemType)" v-html="replaceToLink(auth.authorizationItem.description)">
												</div>
												<v-row class="mt-2">
													<v-col v-if="auth.authorizationItem.systemType === 1" cols="12" md="12" class="text-center">
														<IceManager :isAdmin="true" :userId="localData.memberModel.id" :isSummery="false" />
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 2" cols="12" md="12" class="text-center">
														<IranValidityManager :isAdmin="true" :userId="localData.memberModel.id" :isSummery="false" />
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 4" cols="12" md="12" class="text-center">
														<RefahAuthorizationItem :data="auth.memberDescription" />
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 5" cols="12" md="12" class="text-center">
														<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
															<v-col cols="12" md="3">
																<ImageUploader :ref="'imageUploader' + auth.id + index" :downloadFileName="auth.authorizationItem.title + '-' + localData.memberModel.fullName" :downloadable="true" :editable="attachment.attachmentByAdmin || !attachment.attachment" v-model="attachment.base64" :fileUrl="attachment.fileUrl" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(attachment.base64)" @delete="() => attachment.attachment = ''" />
															</v-col>
															<v-col cols="12" md="9">
																<DigitalSignSms :auth="auth" :member="localData.memberModel" area="admin" @updated="reloadAuthorizeItem(auth.id)" />
															</v-col>
														</v-row>
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 6" cols="12" md="12" class="text-center">
														<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
															<v-col cols="12" md="12">
																<ThirdPersonDigitalSignSms :thirdPersonAssuranceAuthorizationItem="auth.thirdPersonAssuranceAuthorizationItem" :auth="auth" area="admin" @updated="reloadAuthorizeItem(auth.id)" />
															</v-col>
														</v-row>
													</v-col>
													<v-col v-if="auth.authorizationItem.systemType === 0" cols="12" md="12" class="pb-0 text-center">
														<v-row v-for="(attachment, index) in auth.attachments.filter(x => x.rowState !== 'deleted')" :key="attachment.id + index" style="border-bottom: 1px dashed #ccc;">
															<v-col cols="12" md="3">
																<ImageUploader :ref="'imageUploader' + auth.id + index" :downloadFileName="auth.authorizationItem.title + '-' + localData.memberModel.fullName" :downloadable="true" :editable="attachment.attachmentByAdmin || !attachment.attachment" v-model="attachment.base64" :fileUrl="attachment.fileUrl" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(attachment.base64)" @delete="() => attachment.attachment = ''" />
															</v-col>
															<v-col cols="12" md="9" class="text-right">
																<div>توضیحات مشتری:</div>
																<div class="grey--text" style="border-bottom: 1px dashed grey;padding-bottom: 5px;">
																	<div v-if="attachment.memberDescription" style="white-space: pre-line;">
																		{{ attachment.memberDescription }}
																	</div>
																	<div v-else>
																		توضیحاتی ثبت نشده است
																	</div>
																</div>
															</v-col>
														</v-row>
														<div class="mb-2 mt-5">
															<v-btn @click="addAttachment(auth.attachments)">افزودن ردیف
																پیوست</v-btn>
														</div>
													</v-col>
													<v-col cols="12">
														تغییر وضعیت:
														<v-btn-toggle dense class="my-2" v-model="auth.status" tile outlined color="deep-purple accent-3">
															<v-btn :value="0">
																منتظر کاربر
															</v-btn>
															<v-btn :value="5">
																ثبت شده توسط کاربر
															</v-btn>
															<v-btn :value="10">
																منتظر کارشناس
															</v-btn>
															<v-btn :value="15">
																ناقص
															</v-btn>
															<v-btn :value="20">
																تایید شده
															</v-btn>
														</v-btn-toggle>
														<div class="d-flex">
															<span class="pt-2 pl-1">
																نظر کارشــناس:
															</span>
															<v-text-field dense v-model="auth.adminDescription" outlined :error-messages="errorMessages" />
														</div>
														<div class="text-left">
															<v-btn class="mb-3" color="secondary" :loading="submitAuthorizeItemLoading === auth.id" dark @click="submitAuthorizeItem(auth, index)">
																ثبت
															</v-btn>
															<v-btn class="mb-3 mr-2" icon small color="red" :loading="deleteAuthorizeItemLoading === auth.id" dark @click="deleteAuthorizeItem(auth)">
																<v-icon>
																	mdi-trash-can-outline
																</v-icon>
															</v-btn>
														</div>
													</v-col>
												</v-row>
											</div>
										</v-card>
									</v-col>
								</v-row>
							</div>
							<div class="text-center mt-2">
								<v-btn class="mx-auto" color="info" dark @click="addAuthorizeItem()" :loading="authorizationItemsLoading">
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									افزودن مدرک
								</v-btn>
							</div>
						</v-col>
					</v-row>
					<v-dialog v-model="authorizationItemsDialog" scrollable persistent max-width="1000px">
						<AuthorizationItems @select="addSelection" v-if="authorizationItemsDialog" @close="authorizationItemsDialog = false" :loan="localData.loanModel" />
					</v-dialog>

					<v-dialog v-model="extraDataDialog" scrollable persistent max-width="450px">
						<v-card>
							<v-card-title>
								<span class="headline">اطلاعات تکمیلی ثبت وام</span>
								<v-spacer />
								<v-btn @click="extraDataDialog = false" icon>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-container>
									<v-form ref="extraDataform" class="mx-2" lazy-validation @submit.prevent="validateNewUserLoan">
										<v-row>
											<v-col cols="12" md="12">
												<div class="d-flex mb-1">
													<span class="ml-2" style="width:120px">تاریخ شروع وام:</span>
													<date-picker ref="saveDate" v-model="localData.userLoan.startDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" />
												</div>
												<div class="red--text">
													{{ startDatePickerValidatioin }}
												</div>
											</v-col>
											<v-col cols="12" md="12" v-if="!localData.agentModel">
												<div class="d-flex mb-1">
													<span class="ml-2" style="width:120px">سررسید واریز به حساب
														مشتری:</span>
													<date-picker ref="depositChargeDueDate" v-model="localData.userLoan.depositChargeDueDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" />
												</div>
												<div class="red--text">
													{{ depositChargeDueDatePickerValidatioin }}
												</div>
											</v-col>
											<v-col cols="12" md="12" class="mb-5" v-if="localData.agentModel">
												<div class="d-flex mb-2">
													<div class="ml-2" style="width:120px">سررسید نماینده:</div>
													<div>
														<date-picker ref="saveDate" v-model="localData.userLoan.agentDueDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[(val) => !!val || 'تاریخ سررسید نماینده را به صورت صحیح وارد کنید']" />
														<div><small class="blue--text" @click="offDatesDialog = true" style="cursor:pointer">تعطیلی های
																تقویم</small></div>
													</div>
												</div>
												<div class="red--text">
													{{ agentDuedatePickerValidatioin }}
												</div>
											</v-col>
										</v-row>
										<v-card-actions class="pt-5">
											<v-spacer />
											<v-btn @click="extraDataDialog = false">
												بستن
											</v-btn>
											<v-btn color="blue" dark type="submit" :loading="loading">
												ایجاد وام
											</v-btn>
										</v-card-actions>
									</v-form>
								</v-container>
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-dialog v-model="sponsoreDueDateDialog" scrollable persistent max-width="450px">
						<v-card>
							<v-card-title>
								<span class="headline">تاریخ سررسید پرداخت توسط اسپانسر:</span>
								<v-spacer />
								<v-btn @click="sponsoreDueDateDialog = false" icon>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<v-container>
									<v-form ref="extraDataform" class="mx-2" lazy-validation @submit.prevent="validateSponsoreDueDate">
										<v-row>
											<v-col cols="12" md="12">
												<div class="d-flex mb-1">
													<span class="ml-2">سررسید تسویه:</span>
													<div>
														<date-picker ref="saveDate" v-model="localData.sponsoreDueDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[(val) => !!val || 'تاریخ سررسید تسویه را به صورت صحیح وارد کنید']" />

														<div><small class="blue--text" @click="offDatesDialog = true" style="cursor:pointer">تعطیلی های
																تقویم</small></div>
													</div>
												</div>
												<div class="red--text">
													{{ sponsoreDueDatePickerValidatioin }}
												</div>
											</v-col>
											<v-col cols="12" md="12">
												<div class="d-flex mb-1">
													<span class="ml-2 pt-5">قابل واریز اسپانسر:</span>
													<div>
														<v-text-money dense vari outlined v-model="localData.sponsoreAmount" label="" :error-messages="errorMessages" :rules="[() => localData.sponsoreAmount > 0 || 'قابل واریز اسپانسر باید بزرگتر از 0 باشد']" required />
													</div>
												</div>
											</v-col>
										</v-row>
										<v-card-actions>
											<v-spacer />
											<v-btn @click="sponsoreDueDateDialog = false">
												بستن
											</v-btn>
											<v-btn color="blue" dark type="submit">
												ذخیره
											</v-btn>
										</v-card-actions>
									</v-form>
								</v-container>
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-dialog v-model="offDatesDialog" scrollable max-width="450px">
						<v-card>
							<v-card-title>
								<div><span class="headline">مدیریت تعطیلی های تقویم</span></div>
								<v-spacer />
								<v-btn @click="offDatesDialog = false" icon>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
								<OffDates v-if="offDatesDialog" @callbck="offDatesDialog = false" />
							</v-card-text>
						</v-card>
					</v-dialog>

					<v-dialog v-model="loanRequestStatusesDialog" scrollable max-width="900px">
						<LoanRequestStatuses v-if="loanRequestStatusesDialog" :statusGroup="statusGroup" @callbck="loanRequestStatusesDialog = false" @close="loanRequestStatusesDialog = false" />
					</v-dialog>

					<v-dialog v-model="changeStatusHistoryDialog" scrollable max-width="900px">
						<ChangeStatusHistory v-if="changeStatusHistoryDialog" :loanRequestId="localData.id" @close="changeStatusHistoryDialog = false" />
					</v-dialog>

					<AppSmsDetail ref="smsHistory" :data="smsHistoryItems" :hideTypesBadge="true" type="ChangeStatus" />

					<confirm-dlg ref="confirm" />
				</div>
			</v-container>
		</v-card-text>
	</v-card>

</template>

<script>
import api from '@/util/app-api'
import { call, get } from 'vuex-pathify'
import toast from '@/util/toast'
import { emptyId } from '@/util/emptyId'
import MemberProfileHeader from '@/components/forms/MemberProfileHeader'
import ImageUploader from '@/components/uploader/ImageUploader'
import RefahAuthorizationItem from '@/components/RefahAuthorizationItem.vue'
import DigitalSignSms from '@/components/loanAuthorizations/DigitalSignSms.vue'
import ThirdPersonDigitalSignSms from '@/components/loanAuthorizations/ThirdPersonDigitalSignSms.vue'
import { sponsorStatuses } from '@/util/enums'
import { includes } from 'lodash'

export default {
	name: 'ModifyRequestView',
	props: {
		data: { type: Object },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		AuthorizationItems: () => import('@/components/forms/AuthorizationItems.vue'),
		OffDates: () => import('@/components/forms/OffDates'),
		LoanRequestStatuses: () => import('@/components/forms/LoanRequestStatuses'),
		ChangeStatusHistory: () => import('@/components/forms/ChangeStatusHistory'),
		AppSmsDetail: () => import('@/components/AppSmsDetails.vue'),
		'member-profile-header': MemberProfileHeader,
		ImageUploader,
		RefahAuthorizationItem,
		IceManager: () => import('@/components/loanAuthorizations/IceManager'),
		IranValidityManager: () => import('@/components/loanAuthorizations/IranValidityManager'),
		'date-picker': () => import('vue-persian-datetime-picker'),
		DigitalSignSms,
		ThirdPersonDigitalSignSms
	},
	data() {
		return {
			offDatesDialog: false,
			sponsoreDueDateDialog: false,
			loanRequestStatusesDialog: false,
			smsHistoryDialog: false,
			statusToggler: 0,
			authorizationItems: [],
			smsHistoryItems: [],
			loading: false,
			loading2: false,
			authorizationItemsDialog: false,
			changeStatusHistoryDialog: false,
			authorizeStepLoading: true,
			submitAuthorizeItemLoading: false,
			deleteAuthorizeItemLoading: false,
			authorizationItemsLoading: false,
			sponsorHistoryLoading: false,
			extraDataDialog: false,
			errorMessages: '',
			localData: { loanModel: {}, memberModel: null, requestDate_Persian: {}, userLoan: {}, sponsorHistoryCount: 0 },
			loans: [],
			overlayImgSrc: '',
			overlay: false,
			agentDuedatePickerValidatioin: '',
			startDatePickerValidatioin: '',
			sponsoreDueDatePickerValidatioin: '',
			depositChargeDueDatePickerValidatioin: '',
			statusGroup: 0,
			smsHistoryLoading: false,
			statusHistoryLoading: false,
			countSms: 0,
			smsHistoryItems: [],
			countStatusHistory: 0,
			sponsors: [],
			showSponsorHistoryList: false,
			sponsorHistoryList: [],
			sponsorStatuses: sponsorStatuses
		}
	},
	computed: {
		statuses: get('loanRequestStatus/statuses'),
		agentStatuses: get('loanRequestStatus/agentStatuses'),
		currentUser: get('auth/getCurrentUser'),
		isLocked() {
			return this.localData.lockedBy && this.localData.lockedBy.userId !== this.currentUser?.userData?.id
		}
	},
	mounted() {
		this.loadLoans().then(() => {
			this.loadData()
			this.loadSmsHistoryItems()
			this.loadStatusHistoryCount()
		})
		this.fetchOffDates()
		this.fetchLoanRequestStatus()
	},
	methods: {
		fetchLoanRequestStatus: call('loanRequestStatus/fetch'),
		calcOffCount: call('offDates/calcOffCount'),
		fetchOffDates: call('offDates/fetch'),
		loadSmsHistoryItems() {
			this.smsHistoryLoading = true
			api.get('admin/AppSms/ListByEntityId/' + this.data.id, null)
				.then(response => {
					this.smsHistoryItems = response
					this.countSms = this.smsHistoryItems?.length || 0
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.smsHistoryLoading = false
				})
		},
		loadStatusHistoryCount() {
			this.statusHistoryLoading = true
			api.get('admin/UserLoanRequestStatusHistory/CountByLoanRequestId/' + this.data.id, null)
				.then(response => {
					this.countStatusHistory = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.statusHistoryLoading = false
				})
		},
		loadAuthorizationItems() {
			if (this.localData.id === emptyId)
				return

			this.authorizeStepLoading = true
			api.get('admin/UserLoanRequestAuthorizationItem/ListByUserLoanRequestId/' + this.localData.id, null)
				.then(response => {
					this.authorizationItems = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.authorizeStepLoading = false
				})
		},
		loadLoans() {
			return api.get('admin/loan/list', null)
				.then(
					response => {
						this.loans = response.map(item => ({
							...item,
							planTitle: `${item.planTitle} (کد طرح: ${item.code})`
						}))
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		loadMember(id) {
			this.loading = true
			api.get('admin/member/get/' + id + "/true", null)
				.then(response => {
					this.localData.memberModel = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		async submit(ignoreSponsoreDueDate = false) {
			if (!this.$refs.form.validate()) { return }
			if (!ignoreSponsoreDueDate && this.localData.status.systemRequestStatus === 26 && this.localData.loanModel.hasSponsore) {
				if (this.localData.loanModel.defaultSponsoreCheckoutDays && (!this.localData.sponsoreDueDate || new Date(this.localData.sponsoreDueDate).getFullYear() === 1)) {
					var today = new Date()
					let dueDate = new Date(new Date().setDate(today.getDate() + this.localData.loanModel.defaultSponsoreCheckoutDays))
					let offCount = await this.calcOffCount({ start: today, end: dueDate })
					if (offCount > 0)
						dueDate = new Date(dueDate.setDate(dueDate.getDate() + offCount))
					this.localData.sponsoreDueDate = dueDate.toISOString()
				}
				this.sponsoreDueDateDialog = true
				setTimeout(() => {
					if (!this.localData.sponsoreAmount)
						this.localData.sponsoreAmount = this.localData.amount
				}, 100)
				return
			}
			var data = {}
			Object.assign(data, this.localData)
			// data.status = this.localData.status.id
			if (this.localData.installment === '')
				this.localData.installment = 0
			data.month = this.localData.month.id
			this.loading2 = true
			api.post('admin/userLoanRequest/' + (this.localData.id === emptyId ? 'create' : 'edit'), data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.loadStatusHistoryCount()
						this.loadSmsHistoryItems()
						this.$emit('callbck', true)
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(err => {
					this.loading2 = false
				})
		},
		async submitSponsor() {
			if (!this.$refs.formSponsor.validate()) {
				toast.error('ابتدا موارد فرم اسپانسر را تکمیل نمایید')
				return
			}
			if (this.localData.id === emptyId) {
				toast.error('ابتدا درخواست وام را ذخیره سپس اقدام به تعیین اسپانسر نمایید.')
				return
			}
			var data = {
				userLoanRequestId: this.localData.id,
				sponsorId: this.localData.sponsorModel?.id
			}
			this.loading2 = true
			api.post('admin/userLoanRequest/submitSponsor', data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(err => {
					this.loading2 = false
				})
		},
		loadData() {
			if (!this.data) {
				this.data = { id: emptyId }
			}
			if (!this.data.id) {
				this.data.id = emptyId
			}
			this.loading = true
			api.get('admin/userLoanRequest/get/' + this.data.id, null)
				.then(response => {
					this.localData = response
					if (this.data.id === emptyId) Object.assign(this.localData, this.data)
					// this.localData.status = { id: this.localData.status }
					this.localData.month = { id: this.localData.month }
					this.loadMember(this.localData.memberModel.id)
					this.loadAuthorizationItems()
					//this.localData.loanModel = this.loans.find(x => x.id === this.localData.loanModel.id)
					this.localData.userLoan = this.localData.userLoan ? { code: this.localData.userLoan.code, agentDueDate_Persian: this.localData.userLoan.agentDueDate_Persian } : {}
					if (this.checkActivePart('sponsor') && this.localData?.loanModel?.assignedToSponsor)
						this.loadSponsors()
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		loadSponsors() {
			if (!this.localData?.loanModel)
				return
			api.get('admin/sponsor/ListByLoanId?loanId=' + this.localData.loanModel.id, null)
				.then(response => {
					this.sponsors = response
				})
				.catch(err => {
					toast.error('خطا در دریافت لیست اسپانسرها, ' + err.message)
				})
				.finally(() => {

				})
		},
		viewImage(img) {
			this.overlay = true
			this.overlayImgSrc = img
		},
		async deleteAuthorizeItem(auth) {
			if (await this.$refs.confirm.open(
				'توجه',
				`آیا از حذف این آیتم مطمئن هستید؟`,
			)) {
				this.deleteAuthorizeItemLoading = auth.id
				api.post('admin/UserLoanRequestAuthorizationItem/delete/' + auth.id, {})
					.then(response => {
						toast.success('آیتم با موفقیت حذف شد.')
						let index = this.authorizationItems.findIndex(x => x.id === auth.id)
						if (index > -1)
							this.authorizationItems.splice(index, 1)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.deleteAuthorizeItemLoading = '' })
			}
		},
		submitAuthorizeItem(auth, index) {

			const formData = new FormData()
			for (let i = 0; i < auth.attachments.length; i++) {
				var fileUploader = Array.isArray(this.$refs['imageUploader' + auth.id + i]) ? this.$refs['imageUploader' + auth.id + i][0] : null

				if (fileUploader && fileUploader.hasFile()) {
					formData.append(`Attachments[${i}].File`, fileUploader.getFile())
				}
				formData.append(`attachments[${i}][id]`, auth.attachments[i].id)
				formData.append(`attachments[${i}][attachment]`, auth.attachments[i].attachment)
				formData.append(`attachments[${i}][rowState]`, auth.attachments[i].rowState)
			}
			formData.append('id', auth.id)
			formData.append('adminDescription', auth.adminDescription)
			formData.append('status', auth.status)
			this.submitAuthorizeItemLoading = auth.id
			api.post('admin/UserLoanRequestAuthorizationItem/edit', formData, { contentType: 'multipart/form-data' })
				.then(response => {
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					// if (fileUploader && fileUploader.hasFile()) {
					// 	fileUploader.toBase64(fileUploader.getFile()).then(res => {
					// 		auth.base64 = res
					// 	})
					// }
					auth.status_Text = response.status_Text
					auth.status = response.status
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitAuthorizeItemLoading = '' })
		},
		reloadAuthorizeItem(id) {
			this.submitAuthorizeItemLoading = id
			api.get('admin/UserLoanRequestAuthorizationItem/get/' + id, {})
				.then(response => {
					let index = this.authorizationItems.findIndex(x => x.id === id)
					if (index > -1)
						this.authorizationItems.splice(index, 1, response)
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(x => { this.submitAuthorizeItemLoading = '' })
		},
		async addSelection(items) {
			this.authorizationItemsDialog = false
			let itemsToAdd = []
			if (items?.length > 0) {
				itemsToAdd = items.filter(x => !this.authorizationItems.some(i => i.authorizationItem.id === x.id))
			}

			if (!itemsToAdd.length)
				return

			this.loading = true
			for (let index = 0; index < itemsToAdd.length; index++) {
				let item = itemsToAdd[index]
				let data = {
					authorizationItemId: item.id,
					systemType: item.systemType,
					userLoanRequestId: this.localData.id,
					memberId: this.localData.memberModel.id
				}
				await api.post('admin/UserLoanRequestAuthorizationItem/create', data)
					.then(response => {
						toast.success(`آیتم ${item.title} با موفقیت اضافه شد.`)
					})
					.catch(err => {
						toast.error(err.message)
					})
			}
			this.loading = false
			this.loadAuthorizationItems()
		},
		async createUserLoanClick() {
			if (!this.localData.installment) {
				toast.error('مبلغ قسط پر نشده است')
				return
			}

			this.localData.userLoan.startDate = ''
			this.localData.userLoan.depositChargeDueDate = null
			if (this.localData.agentModel) {
				let agentLoans = this.localData.agentModel.agentLoans
				if (this.localData.agentModel.agentId) {
					let subAgentLoan = agentLoans?.find(x => x.loanId === this.localData.loanModel?.id)
					if (subAgentLoan?.defaultCheckoutDays) {
						var today = new Date()
						let dueDate = new Date(new Date().setDate(today.getDate() + subAgentLoan.defaultCheckoutDays))
						let offCount = await this.calcOffCount({ start: today, end: dueDate })
						if (offCount > 0)
							dueDate = new Date(dueDate.setDate(dueDate.getDate() + offCount))
						this.localData.userLoan.subAgentDueDate = dueDate.toISOString()
					}

					let agent = await api.get('admin/agent/get/' + this.localData.agentModel.agentId, null)
					if (agent)
						agentLoans = agent.agentLoans
				}
				let agentLoan = agentLoans?.find(x => x.loanId === this.localData.loanModel?.id)
				if (this.localData.otherPercent || (this.localData.chargeType === 0 && agentLoan?.defaultCheckoutDays) || (this.localData.chargeType === 5 && agentLoan?.productCheckoutDays)) {
					var checkoutDays = 0
					if (this.localData.chargeType === 5) {
						checkoutDays = agentLoan.productCheckoutDays
					} else {
						checkoutDays = this.localData.otherPercent?.checkoutDays > 0 ? this.localData.otherPercent.checkoutDays : agentLoan.defaultCheckoutDays
					}
					var today = new Date()
					let dueDate = new Date(new Date().setDate(today.getDate() + checkoutDays))
					let offCount = await this.calcOffCount({ start: today, end: dueDate })
					if (offCount > 0)
						dueDate = new Date(dueDate.setDate(dueDate.getDate() + offCount))
					this.localData.userLoan.agentDueDate = dueDate.toISOString()
				}
			}
			this.extraDataDialog = true
			//this.submitNewUserLoan()
		},
		validateSponsoreDueDate() {
			this.sponsoreDueDatePickerValidatioin = ''
			if (!this.localData.sponsoreDueDate) {
				this.sponsoreDueDatePickerValidatioin = 'تاریخ تسویه را وارد کنید'
				return
			}
			if (!(this.localData.sponsoreAmount > 1)) {
				toast.error('قابل واریز اسپانسر باید بزرگتر از 0 باشد')
				return
			}
			this.sponsoreDueDateDialog = false
			this.submit(true)
		},
		validateNewUserLoan() {
			let isValid = true
			this.startDatePickerValidatioin = ''
			if (!this.localData.userLoan.startDate) {
				this.startDatePickerValidatioin = 'تاریخ شروع را وارد کنید'
				isValid = false
			}
			this.depositChargeDueDatePickerValidatioin = ''
			if (this.$refs.depositChargeDueDate && !this.localData.userLoan.depositChargeDueDate) {
				this.depositChargeDueDatePickerValidatioin = 'سررسید واریز به حساب مشتری را وارد کنید'
				isValid = false
			}
			this.agentDuedatePickerValidatioin = ''
			if (this.localData.agentModel && !this.localData.userLoan.agentDueDate) {
				this.agentDuedatePickerValidatioin = 'تاریخ سررسید نماینده را وارد کنید'
				isValid = false
			}
			if (isValid)
				this.submitNewUserLoan()
		},
		async submitNewUserLoan() {
			var data = {}
			Object.assign(data, this.localData)
			data.month = this.localData.month.id
			this.loading = true
			api.post('admin/userLoan/CreateByUserLoanRequest', data)
				.then(
					response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
						this.extraDataDialog = false
						this.loadData()
					})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => this.loading = false)
		},
		replaceToLink(text) {
			if (!text)
				return ''
			return text.replace(
				/((http|https|ftp|ftps)\:\/\/[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g,
				'<a href="$1" target="_blank">$1</a>'
			)
		},
		showChangeStatusHistory() {
			this.changeStatusHistoryDialog = true
		},
		showSmsHistory() {
			this.$refs.smsHistory.showDetailsList()
		},
		addAttachment(attachments) {
			attachments.push({
				id: emptyId,
				rowState: 'new',
				attachment: '',
				memberDescription: '',
				base64: '',
				AttachmentByAdmin: false,
			})
		},
		addAuthorizeItem() {
			const loadLoanAuthorizeItems = new Promise((resolve, reject) => {
				api.get('admin/LoanAuthorizationItem/ListByLoanId/' + this.localData.loanModel.id, null)
					.then(response => {
						this.localData.loanModel.loanAuthorizationItems = response
						resolve()
					})
					.catch(err => {
						reject()
					})
			})

			const loadAgentLoanAuthorizeItems = new Promise((resolve, reject) => {
				api.get('admin/AgentLoanAuthorizationItem/ListByLoanId/' + this.localData.loanModel.id, null)
					.then(response => {
						this.localData.loanModel.agentLoanAuthorizationItems = response
						resolve()
					})
					.catch(err => {
						reject()
					})
			})

			this.authorizationItemsLoading = true
			Promise.all([loadLoanAuthorizeItems, loadAgentLoanAuthorizeItems])
				.then((res) => {

				}).then((err) => {

				}).finally(() => {
					this.authorizationItemsDialog = true
					this.authorizationItemsLoading = false
				})
		},
		close() {
			api.post('admin/UserLoanRequest/ChangeLockState', { userLoanRequestId: this.localData.id, lock: false })
				.then(response => {
				})
				.catch(err => {
					toast.error(err.message)
				})
			this.$emit('close')
		},
		loadSponsorHistory() {
			if (this.localData.id === emptyId) {
				this.showSponsorHistoryList = true
				return
			}
			this.sponsorHistoryLoading = true
			api.get('admin/UserLoanRequest/GetSponsorHistory?userLoanRequestId=' + this.localData.id, null)
				.then(response => {
					this.showSponsorHistoryList = true
					this.sponsorHistoryList = response
				})
				.catch(err => {
					toast.error('خطا در دریافت لیست تاریخچه تغییرات اسپانسر. ' + err.message)
				})
				.finally(err => {
					this.sponsorHistoryLoading = false
				})
		}
	}
}
</script>

<style></style>
